<template>
  <div class="mt-3"
       :class="{ 'OptLote': showAllInfo }">
    <div class="row col-12 ml-0">
      <div v-if="showAllInfo"
           class="col-12 col-sm-4 mt-3 pl-0">
        <b-form-checkbox v-if="enableSelectAll"
                         v-model="selectAll"
                         @input="selectAllFiles">
          Selecionar todos
        </b-form-checkbox>
      </div>

      <div :class="showAllInfo ? 'paginate col-12 col-sm-4' : 'col-12 d-inline-flex justify-content-center align-items-center marginToBox'">
        <p class="paginate_text small d-inline-block mt-0">
          Página
        </p>

        <button class="paginate_btn btn btn-sm btn-link p-1 ml-1"
                :class="{ 'inactive': page === 1 }"
                :disabled="page === 1"
                name="paginacao"
                type="button"
                title="Página anterior"
                @click="previous">
          <svg class="paginate_icon icon--xxs"
               role="presentation">
            <use :xlink:href="'#' + arrow_left.id" />
          </svg>
        </button>

        <p class="paginate_text small d-inline-block mt-0">
          {{ page }}
        </p>

        <button class="paginate_btn btn btn-sm btn-link p-1 ml-1"
                :class="{ 'inactive': page === lastPage }"
                :disabled="page === lastPage"
                type="button"
                title="Próxima página"
                @click="next">
          <svg class="paginate_icon icon--xxs"
               role="presentation">
            <use :xlink:href="'#' + arrow_right.id" />
          </svg>
        </button>

        <p class="paginate_text small d-inline-block mt-0">
          {{ `de ${lastPage}` }}
        </p>
      </div>
      
      <div v-if="showAllInfo"
           class="perPageBox col-12 col-sm-4 pr-0">
        <label for="perPage"
               class="col-form-label col-form-label-sm">Mostrar</label>
        <select id="perPage"
                v-model="perPage"
                class="custom-select custom-select-sm col-sm-3 ml-2"
                name="perPage"
                @change="updatePerPage">
          <option v-for="perPg in perPageList"
                  :key="perPg"
                  :value="perPg">
            {{ perPg }}
          </option>
        </select>
      </div>
    </div>
  </div>
</template>

<script>
  // Icons
  import arrow_left from '@/assets/icons/arrow-left.svg?sprite'
  import arrow_right from '@/assets/icons/arrow-right.svg?sprite'

  export default {
    name: 'OptionsLote',
    props: {
      page: {
        type: Number,
        default: 1
      },
      perPag: {
        type: Number,
        default: 100
      },
      lastPage: {
        type: Number,
        default: 1
      },
      acceptSelectAll: {
        type: Boolean,
        default: false
      },
      showAllInfo: {
        type: Boolean,
        default: true
      },
      enableSelectAll: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        // Icons
        arrow_left,
        arrow_right,

        // Paginação
        perPage: 100,
        selectAll: false,
        perPageList: [100, 250, 500]
      }
    },
    watch: {
      acceptSelectAll () {
        this.selectAll = this.acceptSelectAll
      }
    },
    beforeMount () {
      this.perPage = this.perPag
    },
    methods: {
      selectAllFiles () {
        this.$emit('selectAllFiles', this.selectAll)
      },
      previous () {
        this.$emit('previousPage', this.page - 1)
      },
      next () {
        this.$emit('nextPage', this.page + 1)
      },
      updatePerPage () {
        this.$emit('updatePerPage', this.perPage)
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import '@/scss/_utilities/_exports';

  .OptLote {
    border-top: pxToRem(1) solid $color-gray-light;
  }

  .paginate {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 0.8rem;    

    &_text {
      font-size: pxToRem(14);
      font-weight: 500;
      margin-bottom: 0;
    }

    &_btn {
      &.inactive {
        .paginate_icon {
          fill: $color-gray;
        }
      }
    }
  }

  .marginToBox {
    margin-bottom: 4.5rem
  }

  .perPageBox {
    margin-top: 0.7rem;
    display: flex;
    justify-content: flex-end;
    align-items: flex-end;
  }
</style>
